__turbopack_context__.v({
  "body": "modal-module__lQS48G__body",
  "content": "modal-module__lQS48G__content",
  "footer": "modal-module__lQS48G__footer",
  "header": "modal-module__lQS48G__header",
  "headerIconClose": "modal-module__lQS48G__headerIconClose",
  "header_title": "modal-module__lQS48G__header_title",
  "modal": "modal-module__lQS48G__modal",
  "overlay": "modal-module__lQS48G__overlay",
  "showOverlay": "modal-module__lQS48G__showOverlay",
});
